//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    titleImage: {
      type: String,
      required: false,
      default: '',
    },
    deals: {
      type: Array,
      required: true,
    },
    more: {
      type: String,
      required: false,
      default: '',
    },
    /* jw: controls whether the carousels width will be based on its container or the viewport */
    relativeToContainer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      carouselOptions: {
        cellAlign: 'left',
        groupCells: true,
        wrapAround: true,
        pageDots: false,
        autoPlay: false,
        contain: true,
        friction: 0.8,
        prevNextButtons: true,
        // Hide disabled buttons
        adaptiveHeight: true,
        on: {
          staticClick: (_e, _pointer, _cellElement, cellIndex) => {
            window.location = this.deals[cellIndex].get_absolute_url;
          },
        },
      },
    };
  },
};
